import React from 'react';
import {MovableComponentProps} from './models';
import {MovableImpl} from './MovableImpl';

export class Movable extends React.Component<MovableComponentProps> {
  render() {
    const movableId = this.props.movableId;
    return (<MovableImpl key={movableId}
                         {...this.props}/>);
  }
}
